<!-- eslint-disable-next-line -->
<template></template>

<script setup>
import { useBreadcrumbsProvider } from '@shared/composables/use-breadcrumbs'
import { onUnmounted, onMounted, reactive, computed } from 'vue'

const props = defineProps({
  label: {
    type: String,
    required: false,
    default: null
  },
  route: {
    type: String,
    required: false,
    default: null
  },
  isNew: {
    type: Boolean,
    default: false
  }
})

const { addBreadcrumb, removeBreadcrumb } = useBreadcrumbsProvider()

const breadcrumb = reactive({
  label: computed(() => props.label),
  route: computed(() => props.route)
})

onMounted(() => {
  addBreadcrumb(breadcrumb)
})

onUnmounted(() => {
  removeBreadcrumb(breadcrumb)
})
</script>
